export default __webpack_public_path__ + "static/media/load.96d9c38e.gif";